export function searchAndWrapPhrase(text: string, phraseToSearch: string, spanClass: string) {
  return text.replace(
    new RegExp(phraseToSearch, 'i'),
    `<span class="${spanClass}">$&</span>`
  );
}

export function escapeHtml(text: string): string {
  return text.replace(/[&<>"']/g, (c) => {
    switch (c) {
      case '&': return '&amp;';
      case '<': return '&lt;';
      case '>': return '&gt;';
      case '"': return '&quot;';
      case "'": return '&#039;';
      default:  return c;
    }
  });
}

export function sanitizeMarkdownToHtml(rawText: string): string {
  if (!rawText) return '';

  let html = rawText
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\n/g, '<br>')
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g,
      `<a href="$2" target="_blank" rel="noopener">$1</a>`);
  return `<p>${html}</p>`;
}
